import {
	clone,
	flattenForAnalytics,
	removeEmpty,
} from "@helpers/object.helper";
import { atom, useAtomValue, createStore, Provider } from "jotai";
import {
	Actioner,
	ErrorActionKeys,
	MessagingActionKeys,
	PerformanceActionKeys,
} from "@services/actioner";
import getFirebase from "@utils/firebase";

const eventsAtom = atom({});
const firebaseStore = createStore();
firebaseStore.set(eventsAtom, {});

let listeners = [];

const Firebase = {
	start: () => {
		listeners = Actioner.addListenerToAllKeysExcluding(
			{
				...ErrorActionKeys,
				...PerformanceActionKeys,
				...MessagingActionKeys,
			},
			(payload) => {
				const key = clone(payload.actionKey);
				const eventData = !key.sensitive
					? flattenForAnalytics(payload)
					: undefined;

				if (firebaseStore.get(eventsAtom)[eventData?.transaction_id]) {
					return;
				}

				firebaseStore.set(eventsAtom, {
					...firebaseStore.get(eventsAtom),
					[eventData?.transaction_id]: true,
				});

				const paramCount = eventData ? Object.keys(eventData).length : 0;
				if (paramCount > 25) {
				} else {
					const clean = removeEmpty(eventData);
					try {
						if (key.label === Actioner.keyDefs.BUY_SET_ACCOUNT_ID.label) {
							const accountId = clean.value.toString();
							getFirebase().analytics().setUserId(accountId);
						} else {
							getFirebase().analytics().logEvent(key.label, clean);
						}
					} catch (e) {
						Actioner.trigger(Actioner.keyDefs.ERROR, e);
					}
				}
			},
		);
	},

	stop: () => {
		listeners.forEach((listener) => {
			listener.remove();
		});
	},
};

export default Firebase;
